import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { API_ENDPOINT } from 'api'
import React from 'react'
import { Page } from 'react-onsenui'
import { headerStyles, images } from '../Styles'

const LoginScreen = props => {
  return (
    <Page className={props.classes.container}>
      <div style={{ textAlign: 'center' }}>
        <div
          style={{
            display: 'inline-block',
            width: '90%',
            maxWidth: 400,
            height: 200,
            backgroundImage: `url(${images.header})`,
            backgroundSize: headerStyles.backgroundSize,
            backgroundRepeat: headerStyles.backgroundRepeat,
            backgroundPosition: 'center',
          }}
        />
      </div>
      <div style={{ textAlign: 'center', marginTop: 50, padding: '20px 40px' }}>
        <TextField
          error={props.loginError}
          required
          fullWidth
          id="name"
          label="Email"
          margin="normal"
          onChange={props.onEmailChange}
          value={props.email}
        />
      </div>
      <div style={{ textAlign: 'center', padding: '0 40px 20px' }}>
        <TextField
          error={props.loginError}
          required
          fullWidth
          id="password"
          label="Contraseña"
          type="password"
          margin="normal"
          onChange={props.onPasswordChange}
          value={props.password}
        />
      </div>
      <div style={{ textAlign: 'center', marginTop: 30 }}>
        {props.loggingIn ? (
          <CircularProgress />
        ) : (
          <Button variant="contained" color="primary" size="large" onClick={props.login}>
            Acceder
          </Button>
        )}
      </div>
      <br />
      <br />
      <Typography
        align="center"
        color="primary"
        style={{ cursor: 'pointer' }}
        onClick={() => props.openLink(API_ENDPOINT + '/password/reset')}>
        Recuperar contraseña
      </Typography>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </Page>
  )
}

const styles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
  },
}

export default withStyles(styles)(LoginScreen)



// WEBPACK FOOTER //
// ./src/screens/LoginScreen.js